<template>
  <div class="bgmusic_mbmain" v-show="showMask">
    <div class="bgmusic_mb" @click="closeMask"></div>
    <div class="bgmusic_main">
      <div>
        <div class="bgmusic_marR24 bgmusic_tab">
          <div class="bgmusic_tabItem hover_hand" :class="tabIndex == index ? 'bgmusic_bac1' : ''" v-for="(item, index) in tabList" :key="index" @click="tabIndex = index">
            {{ item.catsubname }}
          </div>
        </div>
        <div class="clear_btn_mb" @click="clearBgmusic">
          <div class="clear_btn">取消背景音乐</div>
        </div>
      </div>
      <div class="" v-for="(item1, index) in tabList" :key="index" v-if="tabIndex == index">
        <div class="bgmusic_popBox">
          <div class="bgmusic_flexAC input_btn bgmusic_flexJC" v-if="item1.catsubname==='自定义背景音乐'" v-loading="fileloading">
            <input type="file" class="upload" multiple="multiple" accept="audio" @change="setFile($event)">
            <div class="bgmusic_flexAC bgmusic_flexJC pos2">
              <img class="bgmusic_marR10" src="../assets/images/img1/dubbing_file.png" alt="" style="width:18px;height18px">
              <div class="fontS16">本地上传</div>
            </div>
          </div>
          <div class="bgmusic_musicBox bgmusic_flexSB bgmusic_flexAC" v-for="(item2, index2) in item1.bgmusicList" :key="index2">
            <div class="bgmusic_flexDR bgmusic_flexAC">
              <img class="bgmusic_marR16" src="../assets/images/img1/dubbing_musicIcon.png" alt="" style="width:60px;height60px" />
              <div>
                <p class="fontS16">{{ item2.bgname }}</p>
                <p class="fontS12 bgmusic_fontC1" v-if="index!=0">
                  {{ formatDuring(item2.bgtimelen) }}
                </p>
              </div>
            </div>
            <div class="bgmusic_flexDR">
              <div class="
                  bgmusic_flexDR
                  bgmusic_flexAC
                  bgmusic_boxL
                  bgmusic_flexJC
                  bgmusic_marR10
                " :class="
                  demo_audio.audiourl == item2.bgmusicurl
                    ? 'bgmusic_boxChose'
                    : ''
                " @click.stop="playReal(item2.bgmusicurl)">
                <img src="../assets/images/pause.png" v-if="demo_audio.audiourl == item2.bgmusicurl" style="width: 14px; height: 14px; margin-right: 5px" />
                <img src="../assets/images/play.png" v-else style="width: 14px; height: 14px; margin-right: 5px" />
                <span class="fontS12 hover_hand ">{{
                  demo_audio.audiourl == item2.bgmusicurl ? "暂停" : "试听"
                }}</span>
              </div>
              <div class="
                  bgmusic_flexDR
                  bgmusic_flexAC
                  bgmusic_boxL
                  bgmusic_flexJC
                  bgmusic_bac1
                " @click="setMusic(item2)">
                <img src="../assets/images/enit.png" alt="" style="width: 14px; height: 14px; margin-right: 5px" />
                <p class="fontS12 hover_hand">使用</p>
              </div>
              <div class="
                  bgmusic_flexDR
                  bgmusic_flexAC
                  bgmusic_boxL
                  bgmusic_flexJC
                " style="margin-left:10px" v-if="item1.catsubname==='自定义背景音乐'" @click="deleteDiyBgMusci(item2.bgid)">
                <img src="../assets/images/img2/joint_off.png" style="width: 14px; height: 14px; margin-right: 5px" />
                <span class="fontS12 hover_hand" style="color:#666">删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayListAudio from "../utils/PlayListAudio.js";
export default {
  props: {
    value: {},
  },
  data() {
    return {
      demo_audio: new PlayListAudio(),
      showMask: false,
      tabList: [],
      tabIndex: 1,
      fileloading: false,
    };
  },
  methods: {
    // 删除自定义背景音乐
    deleteDiyBgMusci(delbgid) {
      this.$confirm('此操作将永久删除该背景音乐, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const url = this.$store.state.app_api + this.$store.state.app_url.uptcustombgmusicapp;
        this.$request.postHttp({ delbgid: delbgid }, url, (res) => {
          this.getDiyMusic()
        })
      })
    },
    //保存背景音乐到vuex
    setMusic(bgcMusic) {
      this.$emit("selectBgmusic", bgcMusic);
    },
    // 取消背景音乐选择
    clearBgmusic() {
      this.$emit("clearBgmusic");
    },
    closeMask() {
      this.showMask = false;
    },
    //从本地选择文件
    setFile(e) {
      this.file = e.target.files[0];
      let self = this;
      this.fileloading = true;
      this.$globalFun.getFile(this.file, (res) => {
        self.fileloading = false;
        if (res.data.model.ismax == "1") {
          self.$message({
            message: "文件大小大于20M，无法上传！",
            type: "warning",
          });
        } else if (res.data.model.ismax == "0") {
          console.log(res)
          let json2 = {
            bgmusicurl: res.data.model.bgmusicurl,
            bgtimelen: res.data.model.bgtimelen,
            bgsize: res.data.model.bgsize,
            bgname: res.data.model.bgname
          }
          const url2 = self.$store.state.app_api + self.$store.state.app_url.crtcustombgmusicapp;
          self.$request.postHttp(json2, url2, (res) => {
            console.log(res)
            if (res.rc === '0') {
              self.$message("文件上传成功");
              self.getDiyMusic()
              return
            } else if (res.rec === '5999') {
              self.$message("自定义背景音已经达到上限，请删除后重新上传");
              return
            }
            self.$message.error("文件上传失败");
          })

        } else {
          self.$message.error("文件上传失败");
        }
      });
    },
    // 获取自定义背景音乐
    getDiyMusic() {
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qrycustombgmusicapp;
      this.$request.postHttp({}, url, (res) => {
        let json = {
          catsubname: '自定义背景音乐',
        }
        json.bgmusicList = res.model
        if (this.end_state) {
          this.$set(
            this.tabList,
            0,
            json
          );
          return
        }
        this.tabList.unshift(json)
        this.end_state = true
      });
    },
    // 获取背景音乐
    getBgdMusic() {
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qrybgmusicv5;
      this.$request.postHttp({}, url, (res) => {
        this.$store.commit("setAllMusics", res.model)
        this.tabList = res.model;
        this.getDiyMusic()
      });
    },
    // 背景音播放事件
    playReal(url) {
      // this.stopAllMusci();
      this.demo_audio.play(url);
    },
    // 格式化时间
    formatDuring(mss) {
      return this.$globalFun.formatDuring(mss);
    },
  },
  mounted() {
    this.getBgdMusic();
    this.showMask = this.value;
  },
  watch: {
    value(newVal, oldVal) {
      this.showMask = newVal;
    },
    showMask(val) {
      this.demo_audio.stop();
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped>
.clear_btn {
  text-align: center;
  width: 100%;
  height: 100%;
  line-height: 46px;
  background-color: rgba(222, 28, 49, 0.2);
  color: #de1c31;
}
.clear_btn_mb {
  margin-top: 20px;
  border-radius: 10px;
  width: 220px;
  height: 46px;
  background-color: #fff;
  overflow: hidden;
  cursor: pointer;
}
.bgmusic_mbmain {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}
.bgmusic_main {
  width: 1215px;
  height: 656px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
}
.bgmusic_tab {
  width: 220px;
  height: 460px;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
  overflow-y: scroll;
}
.bgmusic_tab::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.bgmusic_tab::-webkit-scrollbar-track {
  border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.bgmusic_tab::-webkit-scrollbar-thumb {
  border-radius: 5px; /*滚动条的圆角*/
  background-color: rgba(153, 153, 153, 0.4);
}
.bgmusic_mb {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}
.bgmusic_flexDC {
  display: flex;
  flex-direction: column;
}
.bgmusic_flexDR {
  display: flex;
  flex-direction: row;
}
.bgmusic_flexJC {
  display: flex;
  justify-content: center;
}
.bgmusic_flexAC {
  display: flex;
  align-items: center;
}
.bgmusic_flexWW {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.bgmusic_flexSB {
  display: flex;
  justify-content: space-between;
}
.bgmusic_boxL {
  width: 72px;
  height: 36px;
  border-radius: 5px;
  background-color: #eeeeeeff;
}
.bgmusic_marR10 {
  margin-right: 10px;
}
.bgmusic_marR16 {
  margin-right: 16px;
}
.bgmusic_marR24 {
  margin-right: 24px;
}
.bgmusic_marT70 {
  margin-top: 70px;
}
.bgmusic_bac1 {
  background-color: #74b9ff;
}
.bgmusic_fontC1 {
  color: #999999ff;
}
.bgmusic_popBox {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 970px;
  height: 656px;
  padding: 24px 0 24px 24px;
  background-color: #ffffff;
  border-radius: 10px;
  overflow-y: scroll;
}
.bgmusic_popBox::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.bgmusic_popBox::-webkit-scrollbar-track {
  border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.bgmusic_popBox::-webkit-scrollbar-thumb {
  border-radius: 5px; /*滚动条的圆角*/
  background-color: rgba(153, 153, 153, 0.4);
}

.bgmusic_musicBox {
  width: 440px;
  height: 80px;
  padding-left: 16px;
  padding-right: 16px;
  /* padding: 10px 16px 10px 16px; */
  /* margin-bottom: 10px; */
  margin-right: 24px;
  margin-bottom: 16px;
  background-color: #f8f8f8ff;
  border-radius: 10px;
}
.input_btn {
  display: inline-block;
  width: 440px;
  height: 80px;
  padding-left: 16px;
  padding-right: 16px;
  /* padding: 10px 16px 10px 16px; */
  /* margin-bottom: 10px; */
  margin-right: 24px;
  margin-bottom: 16px;
  background-color: #f8f8f8ff;
  border-radius: 10px;
}
input.upload {
  width: 440px;
  height: 80px;
  opacity: 0;
  position: relative;
  z-index: 2;
}
.pos2 {
  position: relative;
  top: -52px;
  z-index: 1;
}
.bgmusic_tabItem {
  text-align: center;
  width: 220px;
  height: 46px;
  line-height: 46px;
  background-color: #ffffff;
  border-bottom: 1px solid #f8f8f8ff;
}
.bgmusic_bac1 {
  background-color: #74b9ff;
}
.bgmusic_boxChose {
  background-color: rgba(116, 185, 255, 0.2);
  color: #74b9ff;
}
</style>





// WEBPACK FOOTER //
// src/components/bgdmusic.vue